export default __webpack_public_path__ + "static/media/idcarderror.3227457b.svg";